(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/*
		This directive provides the an editor for a specific product
		property. It uses needs scope provides for the property. It provides
		a single function to allow for he addition of new attributes.
	*/

	ngModule.directive('productPropertySelector', function () {
		return {
			scope: {
				property: '=',
                selections: '='
			},
			templateUrl: 'directives/productPropertySelector/table.html',
			controller: function($scope) {
				/* If we get a property without attributes, then create an array. */
				if (!$scope.property.attributes) $scope.property.attributes = [];

				/* Setup an initial values for a name and price. */
				$scope.new = { name: '', price: 0 };

                /* Triggers when the selection changes. */
                $scope.$watch('purchased', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // Set the selected attributes for the property.
                        $scope.property.purchased = $scope.property.attributes[newValue];

                        $scope.$emit('selectionChanged');
                    }
                });

                $scope.selected = null;
                $scope.name = $scope.property.type;

				/* Function to add a new attributes. */
				$scope.add = function() {
					$scope.property.attributes.push(angular.copy($scope.new));
				};
			}
		};

	});

})();
